import { retrieveToken } from '../storage';
import {
  wrapFetch,
  wrapFetchWithDetailedErrors,
  apiFetch,
  apiError,
  CARICAMENTO_IMMAGINE_NON_VALIDA,
  SALVATAGGIO_DATI_NON_CORRETTI,
} from './api';

const BASE_URL = process.env.REACT_APP_BACKEND_ENDPOINT;

export const getParagrafiManualePersonalizzato = (manualeId) => {
  const token = retrieveToken();
  const authtoken = 'Bearer '.concat(token);
  const PATH = '/api/paragrafi';
  let query =
    '?manualeId.equals=' +
    manualeId +
    '&page=0&size=1000&sort=numeroParagrafo,ASC';
  const URL = BASE_URL + PATH + query;
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
export const putModificaParagrafiManualePersonalizzato = (body) => {
  const token = retrieveToken();
  const PATH = '/api/paragrafi/personalizzati';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(body),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Salvataggio non riuscito: il manuale o un suo paragrafo non esiste più. Ricaricare la pagina.',
    }),
  );
};
export const getContenutoParagrafo = (id) => {
  const token = retrieveToken();
  const PATH = '/api/paragrafi/personalizzati/contenuto/' + id;
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};

export const postUploadImmaginiSottoparagrafi = (file) => {
  const PATH = '/api/paragrafi/sottoparagrafi/immagini/';
  const URL = BASE_URL + PATH;
  let formData = new FormData();
  formData.append('file', file);
  return wrapFetch(
    apiFetch(URL, {
      method: 'POST',
      body: formData,
    }),
    apiError({
      400: CARICAMENTO_IMMAGINE_NON_VALIDA,
      413: CARICAMENTO_IMMAGINE_NON_VALIDA,
    }),
  );
};

export const updateSottoparagrafi = (body) => {
  const token = retrieveToken();
  const PATH = '/api/paragrafi/personalizzati/contenuto';
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'PUT',
      headers: {
        Authorization: authtoken,
        'Content-Type': 'application/json',
      },
      withCredentials: true,
      credentials: 'include',
      body: JSON.stringify(body),
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: 'Salvataggio non riuscito: il manuale o un suo paragrafo non esiste più. Ricaricare la pagina.',
    }),
  );
};

export const postAggiuntaPDFForParagrafo = (formData) => {
  const token = retrieveToken();
  const authtoken = `Bearer ${token}`;
  const PATH = `/api/files`;
  const URL = BASE_URL + PATH;

  return wrapFetchWithDetailedErrors(
    apiFetch(URL, {
      method: 'POST',
      headers: {
        Authorization: authtoken,
        // "Content-Type": "multipart/form-data",
      },
      withCredentials: true,
      credentials: 'include',
      body: formData,
    }),
    apiError({
      400: SALVATAGGIO_DATI_NON_CORRETTI,
      404: SALVATAGGIO_DATI_NON_CORRETTI,
      409: 'Caricamento del file non riuscito.',
    }),
  );
};
export const getPDFForParagrafo = (id) => {
  const token = retrieveToken();
  const PATH = '/api/files?id=' + id;
  const URL = BASE_URL + PATH;
  const authtoken = 'Bearer '.concat(token);
  return wrapFetch(
    apiFetch(URL, {
      method: 'GET',
      headers: {
        Authorization: authtoken,
      },
      withCredentials: true,
      credentials: 'include',
    }),
    apiError(),
  );
};
